/** @jsx jsx */
import React, { useState } from "react";
import { jsx, css } from "@emotion/core";

import { ColoredH2 } from "../../components/ColoredHeader";
import { CenteredHero } from "../../components/HeroImage";
import Logo from "../../components/Logo";

import { colors } from "../../theme";
import hero from "./assets/dog.png";

const paragraphStyle = css`
    margin: 0 auto;
`;

const logoStyles = css`
    align-self: center;
    margin-top: 40px;
    @media (max-width: 520px) {
        margin-top: auto;
    }
`;

const WaitlistCopy = () => (
    <>
        We are reviewing your application and will email you within the next 2
        working days. If you need any help,{" "}
        <a href="mailto:support@mytutor.co.uk">just get in touch</a>.
    </>
);

const ReviewingApplication = () => {
    return (
        <>
            <CenteredHero
                width={200}
                marginTop={40}
                src={hero}
                alt="Illustration of a dog waiting for a walk"
            />
            <ColoredH2 color={colors.accent5}>
                We've received your application
            </ColoredH2>
            <p css={paragraphStyle}>
                <WaitlistCopy />
            </p>
            <div css={logoStyles}>
                <Logo />
            </div>
        </>
    );
};

export default ReviewingApplication;
